import 'react';
import 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Box';
import 'reakit/Block';
import Inline from 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import 'reakit/List';
import '../List/styled.js';
import '../List/ListItem.js';
import { List } from '../List/index.js';
import 'reakit/Navigation';
import '../Navigation/styled.js';
import { a as Navigation } from '../chunk-18be6601.js';
import '../Navigation/index.js';
import 'reakit/Link';
import '../Link/styled.js';
import { Link } from '../Link/index.js';
var Breadcrumb = styled(Navigation).withConfig({
  displayName: "styled__Breadcrumb",
  componentId: "zajvqz-0"
})(["& li + li::before{border-right-color:", ";border-right-style:solid;border-right-width:", "rem;content:'';display:inline-block;height:0.8rem;margin:0 ", "rem;transform:rotate(15deg);}& [aria-current='page']{font-weight:", ";text-decoration:none;}&{", ";}"], function (props) {
  return palette(props.separationColor || 'text100', props.separationColor);
}, space(0.5), space(2), theme('fannypack.fontWeights.semibold'), theme('fannypack.Breadcrumb.base'));
var BreadcrumbList = styled(List).withConfig({
  displayName: "styled__BreadcrumbList",
  componentId: "zajvqz-1"
})(["& li{margin-right:0;}&{", ";}"], theme('fannypack.Breadcrumb.List.base'));
var BreadcrumbStep = styled(List.Item).withConfig({
  displayName: "styled__BreadcrumbStep",
  componentId: "zajvqz-2"
})(["&{", ";}"], theme('fannypack.Breadcrumb.Step.base'));
var BreadcrumbSpan = styled(Inline).withConfig({
  displayName: "styled__BreadcrumbSpan",
  componentId: "zajvqz-3"
})(["&{", ";}"], theme('fannypack.Breadcrumb.Span.base'));
var BreadcrumbLink = styled(Link).withConfig({
  displayName: "styled__BreadcrumbLink",
  componentId: "zajvqz-4"
})(["&{", ";}"], theme('fannypack.Breadcrumb.Link.base'));
export { Breadcrumb, BreadcrumbLink, BreadcrumbList, BreadcrumbSpan, BreadcrumbStep };